import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export interface TemplateUsage {
  active_count: number;
  historical_count: number;
  active_assessments: { vendor_name: string; status: string; due_date: string }[];
  historical_assessments: { vendor_name: string; status: string; due_date: string }[];
}

export function useTemplateUsage(templateId: string | undefined) {
  return useQuery<TemplateUsage>({
    queryKey: ['template-usage', templateId],
    enabled: !!templateId,
    queryFn: async () => {
      const { data } = await apiClient.get<{ data: TemplateUsage }>(
        `/assessment-templates/${templateId}/usage`,
      );
      return data.data;
    },
  });
}

export function useTemplateLastModified(templateId: string | undefined) {
  return useQuery<{ at: string; actor_user_id: string; actor_email: string | null } | null>({
    queryKey: ['template-last-modified', templateId],
    enabled: !!templateId,
    queryFn: async () => {
      try {
        const { data } = await apiClient.get<{ data: { at: string; actor_user_id: string; actor_email: string | null } }>(
          `/assessment-templates/${templateId}/last-modified`,
        );
        return data.data;
      } catch {
        return null;
      }
    },
  });
}
